<template>
  <div class="panel-names">
    <div class="report-tabs">
      <v-contextmenu @contextmenu="displayVNode" ref="contextmenu">
        <v-contextmenu-item @click="detailTabDelete">删除</v-contextmenu-item>
        <v-contextmenu-item @click="detailTabRename">重命名</v-contextmenu-item>
        <v-contextmenu-item @click="detailTabCopy">复制</v-contextmenu-item>
      </v-contextmenu>
      <div
        :key="index"
        :ref="`reportTab${index}`"
        class="report-tab"
        v-for="(item, index) in panelList">
        <div :class="displayDetailTabIndex === index ? 'activated' : ''"
             @click="clickDetailPanel(index)"
             class="tab"
             v-contextmenu:contextmenu>
          <span>{{item.name}}</span>
        </div>
      </div>
      <div @click="addReportTabDialog = true" class="add-tab-icon">
        <i class="el-icon-plus"></i>
      </div>
      <div class="dialog">
        <el-dialog :visible.sync="addReportTabDialog" title="增加面板"
                   :append-to-body="true" width="360px">
          <el-form :model="addReportTabForm" :rules="addReportTabRules" ref="addReportTabForm">
            <el-form-item label="面板名称" prop="name">
              <el-input autocomplete="off" v-model="addReportTabForm.name"></el-input>
            </el-form-item>
          </el-form>
          <div class="dialog-footer" slot="footer">
            <el-button @click="addReportTabDialog = false">取 消</el-button>
            <el-button @click="toAddReportTab('addReportTabForm')" type="primary">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible"
                   title="重命名面板"
                   width="30%"
                   :append-to-body="true">
          <el-input v-model="contextMenuText"></el-input>
          <span class="dialog-footer" slot="footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button @click="confirmRename" type="primary">确 定</el-button>
        </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import request from '../../utils/request';

export default {
  data() {
    return {
      // 增加面板
      addReportTabDialog: false,
      addReportTabForm: {
        name: '',
      },
      addReportTabRules: {
        name: [{ required: true, message: '请输入需要增加的面板名称', trigger: 'blur' }],
      },
      contextMenuText: '',
      contextMenuIndex: 0,
      dialogVisible: false,
    };
  },
  mounted() {
  },
  // watch: {
  //   panelListData: this.panelList,
  // },
  computed: {
    ...mapGetters('Engineering', ['getPanelList']),
    ...mapState('Engineering', ['displayDetailTabIndex', 'panelList']),
  },
  methods: {
    ...mapMutations('Engineering', ['clickDetailTab', 'addPanel', 'setCurPanelId', 'setPanelData_cg']),
    ...mapActions('Engineering', [
      'addReportTab',
      'setReportTabName',
      'deleteReportTab',
      'getInitPanelData',
      'copyDetailTab',
      'panelIdStatus',
      'panelSubscriptionClose',
    ]),
    // 获取当前被右键的节点名称
    displayVNode(vnode) {
      this.contextMenuText = vnode.elm.innerText;
      this.contextMenuIndex = this.panelList.map(item => item.name).indexOf(this.contextMenuText);
    },
    // 切换面板
    clickDetailPanel(index) {
      const { panelList } = this;
      this.clickDetailTab({ index, that: this });
      // 因为运行层级变为了project，注掉下面一些函数，wkb
      // 取消之前的面板订阅
      // this.panelSubscriptionClose();
      // 将当前的面板id保存在vuex中
      this.setCurPanelId(panelList[index].id);
      // 判断新打开的面板状态，如果是打开状态，则自动打开订阅
      // this.panelIdStatus({ panelId: panelList[index].id, projectId: this.$route.params.id });
      this.setPanelData_cg([]);
      // 获取当前面板数据
      this.getInitPanelData({
        panelId: panelList[index].id,
        that: this,
        panelIdIndex: index,
      });
    },
    toAddReportTab(formName) {
      const self = this;
      self.$refs[formName].validate((valid) => {
        if (valid) {
          self.addReportTab({
            projectId: self.$route.params.id,
            panelName: self.addReportTabForm.name,
          }).then(() => {
            // 如果增加成功，dialog消失
            self.$refs[formName].resetFields();
            self.addReportTabDialog = false;
            self.clickDetailPanel(self.panelList.length - 1);
          });
        }
      });
    },
    detailTabDelete() {
      this.$confirm('此操作将会删除该面板, 是否继续?', '删除指定面板', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.deleteReportTabPanel();
      }).catch(() => {
      });
    },
    async deleteReportTabPanel() {
      if (this.panelList.length === 1) {
        this.$message.info('无法删除仅存的面板');
        return;
      }
      const res = this.deleteReportTab({
        panelId: this.panelList[this.contextMenuIndex].id,
        contextMenuIndex: this.contextMenuIndex,
      });
      if (res) {
        this.$message({
          showClose: true,
          message: '面板已删除！',
          type: 'success',
        });
      } else {
        this.$message({
          showClose: true,
          message: '删除错误！',
          type: 'error',
        });
      }
    },
    detailTabRename() {
      this.dialogVisible = true;
    },
    detailTabCopy() {
      const panelId = this.panelList[this.contextMenuIndex].id;
      this.$confirm('此操作将会复制该面板, 是否继续?', '创建面板副本', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        request.post('panel/copy', {
          panelId,
        }).then((res) => {
          this.addPanel({ panel: res });
        }).catch(() => {
        });
      }).catch(() => {
      });
    },
    async confirmRename() {
      this.dialogVisible = false;
      const re = await this.setReportTabName({
        panelId: this.panelList[this.contextMenuIndex].id,
        index: this.contextMenuIndex,
        name: this.contextMenuText,
      });
      if (re) {
        this.$message({
          type: 'success',
          message: '修改成功',
        });
      } else {
        this.$message({
          type: 'error',
          message: '修改失败',
        });
      }
    },
  },
};
</script>

<style lang="scss">
  .report-tabs {
    display: flex;
    flex-direction: row;
    align-items: center;
    border: solid 1px #eee;

    .report-tab {
      cursor: pointer;
      text-align: center;
      border-right: solid 1px #ddd;

      .tab {
        padding: 5px 10px;
        line-height: 30px;
        white-space: nowrap;

        &.activated {
          background-color: #ddd;
        }
      }
    }

    .add-tab-icon {
      padding-top: 5px;
      padding-bottom: 5px;
      width: 30px;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
      border-right: solid 1px #ddd;
    }

    .dialog{
      z-index: 2000!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/engineering/ReportTabs.vue